import axios from "axios";
import React, { useState } from "react";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function DeleteProfileImgModal({
  cancelModal,
  fetchData,
  reviewPendingClub,
}) {
  const [deleteComplete, setDeleteComlete] = useState(false);
  const { user } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  //styled =

  const handleDelete = async () => {
    setIsLoading(true);

    try {
      const imgDeleteResponse = await axios.delete(
        `${ApiConnectionString}/api/PendingClub/image`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (imgDeleteResponse.status === 200) {
        setDeleteComlete(true);
        fetchData();
        reviewPendingClub();
      }
    } catch (error) {
      console.error("Error deleting the image:", error);
      // Optionally handle the error, such as showing a notification
    } finally {
      setIsLoading(false); // Always stop loading
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
          <div className="send-modal-footer"></div>
        </div>
      </div>
    );
  }

  if (deleteComplete) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <div className="blueBanner">
            <p className="fw-bold m-2 p-2 fontSize20">Image Deleted</p>
          </div>
          <button
            type="button"
            className="close-button"
            onClick={cancelModal}
            aria-label="Close"
          >
            &times;
          </button>
          <p>The image has been successfully deleted.</p>

          <div className="send-modal-footer">
            <button
              onClick={cancelModal}
              className="pointer cancelButton fw-bold mx-2 px-3"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <div className="blueBanner">
            <p className="fw-bold m-2 p-2 fontSize20">Image Deleted</p>
          </div>
          <button
            type="button"
            className="close-button"
            onClick={cancelModal}
            aria-label="Close"
          >
            &times;
          </button>
          <p>Are you sure you want to delete this image?</p>

          <div className="send-modal-footer">
            <button className="saveChanges-button mx-3" onClick={handleDelete}>
              Confirm
            </button>
            <button
              onClick={cancelModal}
              className="pointer cancelButton fw-bold mx-2 px-3"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  }
}
